import { useGarmentImage } from '@/hooks/useGarmentImage';
import type { Garment } from '@/types';

interface Props {
  garment: Garment;
  size?: 'sm' | 'md';
  selected?: boolean;
  onClick?: () => void;
}

export function ExistingGarmentThumb({ garment, size = 'sm', selected, onClick }: Props) {
  const imageUrl = useGarmentImage(garment.imageUrls?.[0] || garment.thumbnailUrl);
  const dim = size === 'sm' ? 'w-14 h-14' : 'w-20 h-20';

  return (
    <button
      onClick={onClick}
      className={`${dim} rounded-lg overflow-hidden flex-shrink-0 border-2 transition-colors ${
        selected ? 'border-[#6C3CE1] ring-1 ring-[#6C3CE1]' : 'border-gray-200 hover:border-[#6C3CE1]/50'
      }`}
      style={{
        backgroundImage: 'linear-gradient(45deg, #f0f0f0 25%, transparent 25%), linear-gradient(-45deg, #f0f0f0 25%, transparent 25%), linear-gradient(45deg, transparent 75%, #f0f0f0 75%), linear-gradient(-45deg, transparent 75%, #f0f0f0 75%)',
        backgroundSize: '8px 8px',
        backgroundPosition: '0 0, 0 4px, 4px -4px, -4px 0px',
        backgroundColor: '#fafafa',
      }}
    >
      {imageUrl ? (
        <img src={imageUrl} alt={garment.name || garment.category} className="w-full h-full object-contain" />
      ) : (
        <div className="w-full h-full flex items-center justify-center text-[10px] text-gray-400 capitalize">
          {garment.category}
        </div>
      )}
    </button>
  );
}
